import Client from './Client'
import Contract from './Contract'
import Tax from './Tax'
import Plan from './Plan'
import Summary from './Summary'
import Finish from './Finish'

export default {
  Client,
  Contract,
  Tax,
  Plan,
  Summary,
  Finish,
}
